<template>
  <div class="w-full h-full relative flex justify-center">
    <div class="p-8 w-full">
      <div class="flex justify-end"></div>
    </div>
    <div class="w-full absolute bottom-[10%] flex flex-col items-center">
      <div class="relative flex items-center justify-center w-3/4">
        <div class="relative z-[2000000000] w-full">
          <LottieComponent content="rocket" class="w-full" loop />
        </div>
      </div>
      <div class="py-4"></div>
      <div class="text-white text-3xl font-bold">
        {{ appVersionData.title }}
      </div>
      <div class="py-1"></div>
      <div class="text-xl text-center px-8">
        {{ appVersionData.appUpdateText }}
      </div>
      <div class="py-2"></div>

      <a v-if="appVersionData.appLink" class="buttonComponent" :href="appVersionData.appLink" @click="download">
        Télécharger
      </a>
    </div>
  </div>
</template>

<script>
  import LottieComponent from '../utils/LottieComponent.vue'

  export default {
    components: { LottieComponent },
    name: 'TransactionFinishedScreen',
    data() {
      return {
        appVersionData: {
          title: 'Kingrecharge a été mis à jour',
          appUpdateText:
            'Téléchargez la nouvelle version de Kingrecharge pour bénéficier des nouveautés. Désinstallez l\'ancienne version si vous n\'arivez pas à installer la nouvelle appilcation',
          appLink: 'https://web.kingrecharges.com/download/kingrecharge-latest.apk',
        },
      }
    },
    mounted() {
      // this.loadAppData();
    },
    methods: {
      download() {
        if (self !== top) {
          window.parent.location.href = this.appVersionData?.appLink
        }
      },
      async loadAppData() {
        const appVersionData =
          await this.$Events.sendDataRequestResolve('appVersionData')
        this.appVersionData = appVersionData.metaData
      },
    },
  }
</script>